/* Kitchen 博客文章：目录 + 表格横滑。只在 sections/kitchen-article.liquid 加载。 */
(function () {
  'use strict';

  var SKIP = '.kb-takeaways, .kb-callout, .kb-product-card, .kb-toc';

  function slugify(text) {
    return text.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'section';
  }

  function wrapTables(root) {
    Array.prototype.forEach.call(root.querySelectorAll('table'), function (table) {
      if (table.parentElement.classList.contains('kb-table-scroll')) return;
      var wrap = document.createElement('div');
      wrap.className = 'kb-table-scroll';
      wrap.setAttribute('role', 'region');
      wrap.setAttribute('tabindex', '0');
      wrap.setAttribute('aria-label', 'Table, scroll sideways to see all columns');
      table.parentNode.insertBefore(wrap, table);
      wrap.appendChild(table);
    });
  }

  function buildToc(root) {
    if (root.querySelector('.kb-toc')) return;
    var heads = Array.prototype.filter.call(root.querySelectorAll('h2'), function (h) { return !h.closest(SKIP); });
    if (heads.length < 2) return;

    var nav = document.createElement('nav');
    nav.className = 'kb-toc';
    nav.setAttribute('aria-label', 'On this page');
    var title = document.createElement('p');
    title.className = 'kb-toc__title';
    title.textContent = 'On this page';
    var list = document.createElement('ol');

    heads.forEach(function (h) {
      if (!h.id) {
        var base = slugify(h.textContent);
        var id = base;
        var n = 2;
        while (document.getElementById(id)) { id = base + '-' + n; n += 1; }
        h.id = id;
      }
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.trim();
      li.appendChild(a);
      list.appendChild(li);
    });
    nav.appendChild(title);
    nav.appendChild(list);

    var anchor = root.querySelector('.kb-takeaways') || root.querySelector(':scope > p');
    if (anchor) anchor.insertAdjacentElement('afterend', nav);
    else root.insertBefore(nav, root.firstChild);
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-kb-content]'), function (root) {
      wrapTables(root);
      buildToc(root);
    });
  }

  window.KbArticle = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
